// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mf2y","content":"styles_content__1hiHw"};